import { render, staticRenderFns } from "./EvidenceLink.vue?vue&type=template&id=c0983374&scoped=true"
import script from "./EvidenceLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./EvidenceLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EvidenceLink.vue?vue&type=style&index=0&id=c0983374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0983374",
  null
  
)

/* custom blocks */
import block0 from "./EvidenceLink.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxTextField: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/TextField.vue').default,IxDialogEditEvidence: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/EditEvidence.vue').default,IxDialogTableEvidence: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/TableEvidence.vue').default,IxDataTable: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/DataTable.vue').default})
